import { render, staticRenderFns } from "./SanctionScreening.vue?vue&type=template&id=66b4ac44&"
import script from "./SanctionScreening.vue?vue&type=script&lang=js&"
export * from "./SanctionScreening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports